import { TournamentType } from '@okletsplay/core';
import React, { FC, memo } from 'react';

interface TournamentTypeFormatProps {
  format?: TournamentType;
}

const TOURNAMENT_TYPE_LABELS: Record<TournamentType, string> = {
  [TournamentType.AsyncTournament]: 'Async Tournament',
  [TournamentType.SingleEliminationTournament]: 'Single Elimination',
  [TournamentType.DoubleEliminationTournament]: 'Double Elimination',
};

const TournamentTypeFormatComponent: FC<TournamentTypeFormatProps> = ({ format }) => {
  if (!format) {
    return null;
  }

  return <>{TOURNAMENT_TYPE_LABELS[format]}</>;
};

export const TournamentTypeFormat = memo(TournamentTypeFormatComponent);
